import { Form, Row, Col } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const QASection = ({
  data,
  qaAnswers,
  setFormData,
  errors,
  locale,
  selectedGcycleId,
}) => {
  const handleChange = (questionId, value) => {
    setFormData((prev) => ({
      ...prev,
      qaAnswers: {
        ...prev.qaAnswers,
        [questionId]: {
          ...prev.qaAnswers?.[questionId],
          value,
        },
      },
    }));
  };

  const shouldShowQuestion = (question) => {
    let gradeCycles = [];

    try {
      gradeCycles = JSON.parse(question.adm_grade_cycles || "[]");
    } catch (e) {
      gradeCycles = [];
    }

    // Case 1: empty → show for all
    if (gradeCycles.length === 0) return true;

    // Case 2: gcycle match
    return gradeCycles.includes(selectedGcycleId);
  };

  return (
    <Row>
      <Col lg={8} xl={7} className="qa-section">
        {data
          ?.sort((a, b) => a.admg_order - b.admg_order)
          .map((group) => (
            <div key={group.admg_id} className="mb-5">
              <h5 className="mb-3">
                {locale === "en" ? group.admg_title : group.admg_title_ar}
              </h5>

              {group?.admission_questions
                ?.filter((question) => shouldShowQuestion(question))
                .map((question) => (
                  <div key={question.adm_quest_id} className="mb-4">
                    <Form.Label>
                      {locale === "en"
                        ? question.adm_desc
                        : question.adm_desc_ar}{" "}
                      {question.adm_mandatory === 1 && (
                        <span className="text-danger">*</span>
                      )}
                    </Form.Label>

                    {question.adm_tf === 1 ? (
                      <>
                        <Row className="mb-2">
                          <Col xs={"auto"}>
                            <Form.Check
                              type="radio"
                              label={locale === "en" ? "True" : "صحيح"}
                              name={`q_${question.adm_quest_id}`}
                              id={`q_${question.adm_quest_id}_true`}
                              onChange={() =>
                                handleChange(question.adm_quest_id, 1)
                              }
                              checked={
                                qaAnswers[question.adm_quest_id]?.value == 1
                              }
                            />
                          </Col>
                          <Col xs={"auto"}>
                            <Form.Check
                              type="radio"
                              label={locale === "en" ? "False" : "خطأ"}
                              name={`q_${question.adm_quest_id}`}
                              id={`q_${question.adm_quest_id}_false`}
                              onChange={() =>
                                handleChange(question.adm_quest_id, 0)
                              }
                              checked={
                                qaAnswers[question.adm_quest_id]?.value == 0
                              }
                            />
                          </Col>
                        </Row>
                      </>
                    ) : question.adm_ddl === 1 ? (
                      // SINGLE SELECT DROPDOWN
                      <Form.Select
                        value={qaAnswers[question.adm_quest_id]?.value || ""}
                        onChange={(e) =>
                          handleChange(question.adm_quest_id, e.target.value)
                        }
                      >
                        <option value="">Select option</option>
                        {JSON.parse(question.adm_ddl_options || "[]").map(
                          (opt, i) => (
                            <option key={i} value={opt}>
                              {opt}
                            </option>
                          ),
                        )}
                      </Form.Select>
                    ) : question.adm_ddl === 2 ? (
                      // MULTI SELECT
                      <div className="border rounded p-3 bg-light">
                        {JSON.parse(question.adm_ddl_options || "[]").map(
                          (opt, i) => {
                            const selected =
                              qaAnswers[question.adm_quest_id]?.value?.includes(
                                opt,
                              );

                            return (
                              <Form.Check
                                key={i}
                                type="checkbox"
                                label={opt}
                                checked={selected}
                                className="mb-2"
                                onChange={(e) => {
                                  const current =
                                    qaAnswers[question.adm_quest_id]?.value ||
                                    [];

                                  const values = e.target.checked
                                    ? [...current, opt]
                                    : current.filter((v) => v !== opt);

                                  handleChange(question.adm_quest_id, values);
                                }}
                              />
                            );
                          },
                        )}
                      </div>
                    ) : (
                      // <Form.Select
                      //   multiple
                      //   value={qaAnswers[question.adm_quest_id]?.value || []}
                      //   onChange={(e) => {
                      //     const values = Array.from(
                      //       e.target.selectedOptions,
                      //       (option) => option.value,
                      //     );
                      //     handleChange(question.adm_quest_id, values);
                      //   }}
                      // >
                      //   {JSON.parse(question.adm_ddl_options || "[]").map(
                      //     (opt, i) => (
                      //       <option key={i} value={opt}>
                      //         {opt}
                      //       </option>
                      //     ),
                      //   )}
                      // </Form.Select>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Enter your answer"
                        value={qaAnswers[question.adm_quest_id]?.value || ""}
                        onChange={(e) =>
                          handleChange(question.adm_quest_id, e.target.value)
                        }
                      />
                    )}

                    {/* Optional comment box for True/False */}
                    {question.adm_quest_comment === 1 && (
                      <Form.Control
                        as="textarea"
                        rows={2}
                        className="mt-2"
                        placeholder={
                          locale === "en"
                            ? "Add comment (optional)"
                            : locale === "ar"
                              ? "أضف تعليق (اختياري)"
                              : "Adaugă comentariu (opțional)"
                        }
                        value={qaAnswers[question.adm_quest_id]?.comment || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            qaAnswers: {
                              ...prev.qaAnswers,
                              [question.adm_quest_id]: {
                                ...prev.qaAnswers?.[question.adm_quest_id],
                                comment: e.target.value,
                              },
                            },
                          }))
                        }
                      />
                    )}

                    {errors[`qa_${question.adm_quest_id}`] && (
                      <Form.Text className="text-danger">
                        <FormattedMessage id="error.qa" />
                      </Form.Text>
                    )}
                  </div>
                ))}
            </div>
          ))}
      </Col>
    </Row>
  );
};

export default QASection;
